"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDayOfWeekModifier = void 0;
var isDayOfWeekModifier = function (blackout) {
    return "daysOfWeek" in blackout;
};
exports.isDayOfWeekModifier = isDayOfWeekModifier;
